import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { Client } from "@twilio/conversations"; 
import { Util } from "./util";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ChatService {
  public chatClient: Client; 
  public chatConnectedEmitter: EventEmitter<any> = new EventEmitter<any>();
  public chatDisconnectedEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private router: Router,
    private http: HttpClient // private authService: AuthService,
  ) {
    // this.connectTest("2482", "c5834937-7cb7-40aa-46a4-08d9b8bd406d");
  }

  async connect() {
    return 
  }

  getPublicChannels() {
    
  }

  getChannel(sid: string) { 
  }

  createChannel(friendlyName: string, isPrivate: boolean = false) { 
  }


  async connectTest(appontmentId, toId) {  
    // &ToId=${toId}
    this.http.post<any>(`${environment.baseUrl}TwilioConversations/chat/CreateConversation?AppointmentId=${appontmentId}`, null).subscribe(async (res: any) => {
      if (!res.data) return 
      let token: string = res.data.token;
      this.chatClient = new Client(token); 
    });  
  }

  sendNotification = (ids) => this.http.post<any>(`${environment.baseUrl}Notification/SendNotification`, ids)


  }
